export default __webpack_public_path__ + "static/media/27.93ad5c84.png";